// Shared helper — extract up to two capitalised initials from a display
// name. Used by every avatar in the app (Sidebar, placeholder-components,
// future member list). A whitespace-only label returns "".

export function getInitials(label: string): string {
  return label
    .split(/\s+/)
    .map((word) => word.match(/[\p{L}\p{N}]/u)?.[0] ?? "")
    .filter(Boolean)
    .slice(0, 2)
    .join("")
    .toUpperCase();
}
